import { IAction, KEEP_THE_SAME, StateStatus } from 'redux/utils/common';
import { ICity } from 'services/api/city';
import {
  IAgent,
  IClientListItem,
  IRole,
  ICustomersMiniProfileData,
} from 'services/api/client';
import { IMunicipality } from 'services/api/municipality';
import * as Types from './types';

interface IAttribute {
  value: string;
}
export interface IState {
  clients: {
    status: StateStatus | null;
    data: Array<IClientListItem>;
  };
  clientMiniProfiles: {
    status: StateStatus | null;
    data: ICustomersMiniProfileData | null;
  };
  agents: {
    status: StateStatus | null;
    data: Array<IAgent>;
  };
  deleteCustomerStatus: StateStatus | null;
  roles: {
    status: StateStatus | null;
    data: Array<IRole>;
  };
  sendPassword: {
    status: StateStatus | null;
  };
  addCustomerStatus: StateStatus | null;
  valueSearch: { [key: string]: any };
  clientAttributeCompanyName: {
    status: StateStatus | null;
    data: IAttribute[] | null;
  };
  clientAttributeFoundUsOn: {
    status: StateStatus | null;
    data: IAttribute[] | null;
  };
  city: {
    data: Array<ICity>;
    status: StateStatus | null;
  };
  municipality: {
    data: Array<IMunicipality>;
    status: StateStatus | null;
  };
}

const initialState: IState = {
  clients: {
    status: null,
    data: [],
  },
  clientMiniProfiles: {
    status: null,
    data: null,
  },
  agents: {
    status: null,
    data: [],
  },
  deleteCustomerStatus: null,
  roles: {
    status: null,
    data: [],
  },
  sendPassword: {
    status: null,
  },
  addCustomerStatus: null,
  valueSearch: {},
  clientAttributeCompanyName: {
    status: null,
    data: null,
  },
  clientAttributeFoundUsOn: {
    status: null,
    data: null,
  },
  city: {
    data: [],
    status: null,
  },
  municipality: {
    data: [],
    status: null,
  },
};

const ClientListReducer = (
  state: IState = initialState,
  action: IAction
): IState => {
  switch (action.type) {
    case Types.SET_CLIENTS:
      return {
        ...state,
        clients: {
          ...state.clients,
          status: action.status || null,
          data:
            action.data === KEEP_THE_SAME ? state.clients.data : action.data,
        },
      };
    case Types.SET_AGENTS:
      return {
        ...state,
        agents: {
          ...state.agents,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.SET_CLIENTS_MINI_PROFILES:
      return {
        ...state,
        clientMiniProfiles: {
          ...state.clientMiniProfiles,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.DELETE_CUSTOMER:
      return {
        ...state,
        deleteCustomerStatus: action.status || null,
      };
    case Types.FETCH_ROLES:
      return {
        ...state,
        roles: {
          ...state.roles,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.ADD_CUSTOMER:
      return {
        ...state,
        addCustomerStatus: action.status || null,
      };
    case Types.SEND_PASSWORD:
      return {
        ...state,
        sendPassword: {
          ...state.sendPassword,
          status: action.status || null,
        },
      };
    case Types.SET_VALUE_SEARCH:
      return {
        ...state,
        valueSearch: {
          ...state.valueSearch,
          ...action.data,
        },
      };
    case Types.SET_CLIENT_ATTRIBUTE_FOUND_US_ON:
      return {
        ...state,
        clientAttributeFoundUsOn: {
          ...state.clientAttributeFoundUsOn,
          status: action.status || null,
          data:
            action.data === KEEP_THE_SAME
              ? state.clientAttributeFoundUsOn.data
              : action.data,
        },
      };
    case Types.SET_CLIENT_ATTRIBUTE_COMPANY_NAME:
      return {
        ...state,
        clientAttributeCompanyName: {
          ...state.clientAttributeCompanyName,
          status: action.status || null,
          data:
            action.data === KEEP_THE_SAME
              ? state.clientAttributeCompanyName.data
              : action.data,
        },
      };
    case Types.SET_CITY:
      return {
        ...state,
        city: {
          ...state.city,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.SET_MUNICIPALITY:
      return {
        ...state,
        municipality: {
          ...state.municipality,
          status: action.status || null,
          data: action.data,
        },
      };
    default:
      return {
        ...state,
      };
  }
};

export default ClientListReducer;
